import { render, staticRenderFns } from "./UserOverlay.vue?vue&type=template&id=1185e7f6"
import script from "../../../scripts/partials/user/UserOverlay.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/user/UserOverlay.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports